module.exports = __webpack_public_path__ + "media/images/editorial_board_icons/eb_nemeroff_sm-2157a331ac64cde78925f4452ad99338.png";